import { render, staticRenderFns } from "./returnVisitQuestionnaire.vue?vue&type=template&id=098ac1a8&scoped=true&"
import script from "./returnVisitQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./returnVisitQuestionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./returnVisitQuestionnaire.vue?vue&type=style&index=0&id=098ac1a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ac1a8",
  null
  
)

export default component.exports